export default {
  cards: null,
  card: null,
  roadmaps: null,
  isLoading: false,
  isSubmitting: false,
  errors: null,
  validationErrors: null,
};
